module.exports = __webpack_public_path__ + "static/media/icon-email.d6ded013.svg";